import React from 'react';

export default props => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M10,19c0-1.1,.9-2,2-2s2,.9,2,2-.9,2-2,2-2-.9-2-2Zm13.68-9.46c.41-.38,.43-1.01,.05-1.41-3.02-3.25-7.3-5.12-11.73-5.12S3.29,4.87,.27,8.12c-.38,.41-.35,1.04,.05,1.41,.4,.38,1.04,.35,1.41-.05,2.64-2.85,6.38-4.48,10.27-4.48s7.62,1.63,10.27,4.48c.2,.21,.46,.32,.73,.32,.24,0,.49-.09,.68-.27Zm-5.01,4.81c.41-.38,.43-1.01,.05-1.41-1.73-1.87-4.18-2.94-6.72-2.94s-4.99,1.07-6.72,2.94c-.38,.4-.35,1.04,.05,1.41,.4,.38,1.04,.35,1.41-.05,1.35-1.46,3.27-2.29,5.26-2.29s3.9,.84,5.26,2.29c.2,.21,.46,.32,.73,.32,.24,0,.49-.09,.68-.27Z"
    />
  </svg>
);



// WEBPACK FOOTER //
// ./app/icons/wifi-icon.jsx